<template>
  <div class="ocs container">
    <!-- desktop -->
    <main v-if="isDesktop" class="ocs-d">
      <section class="product-filter">
        <ProductFilter @sectionClick="handleSectionClick"></ProductFilter>
      </section>
      <section class="product-grid">
        <div v-if="Object.keys($route.query).length && isDesktop" class="container-list-filter">
          <div class="list-filter">
            <template v-for="(item, i) in Object.keys($route.query)">
              <div v-if="item === 'category'" :key="i" class="list">
                <span
                  v-for="(category, _i) in listCategoryItems(queryString[item])"
                  :key="_i"
                  class="item-list"
                  @click.prevent="onDeleteItem(item, category._id)"
                >
                  {{ category.name }} <SvgImg class="remove" name="close-black-icon" width="12" height="12" />
                </span>
              </div>
              <div v-if="item === 'brands'" :key="i" class="list">
                <span
                  v-for="(brand, _i) in listSelectedBrand(queryString[item])"
                  :key="_i"
                  class="item-list"
                  @click.prevent="onDeleteItem(item, brand._id)"
                  >{{ brand.name }} <SvgImg class="remove" name="close-black-icon" width="12" height="12"
                /></span>
              </div>
              <div v-if="item === 'origins'" :key="i" class="list">
                <span
                  v-for="(origin, _i) in listSelectedBrandOrigin(queryString[item])"
                  :key="_i"
                  class="item-list"
                  @click.prevent="onDeleteItem(item, origin._id)"
                  >{{ origin.name }} <SvgImg class="remove" name="close-black-icon" width="12" height="12"
                /></span>
              </div>
              <div v-if="item === 'available_for'" :key="i" class="list">
                <span
                  v-for="(available, _i) in listAvailable(queryString[item])"
                  :key="_i"
                  class="item-list"
                  @click.prevent="onDeleteItem(item, available)"
                  >{{ available | changeAvailableName }}
                  <SvgImg class="remove" name="close-black-icon" width="12" height="12"
                /></span>
              </div>
              <div v-if="item === 'rating'" :key="i" class="list">
                <span class="item-list" @click.prevent="onDeleteItem(item, queryString[item])">
                  <i class="icon_star"></i> {{ queryString[item] }}
                  <SvgImg class="remove" name="close-black-icon" width="12" height="12" />
                </span>
              </div>
            </template>
          </div>
          <div v-if="showClearAllButton" class="list-reset">
            <span @click.prevent="reset"> Clear all </span>
          </div>
        </div>
        <ProductGrid :products="products" :title="title" :loading="loading" />
      </section>
    </main>
    <!-- mobile -->
    <main v-else class="ocs-m">
      <section class="product-grid">
        <ProductGrid :products="products" :title="title" :loading="loading" />
        <ModalFilterV2
          v-if="showModalFilterV2"
          :list_brands="$store.state.$_Review.brandList"
          :list_country="$store.state.$_Review.countryList"
          :categories="$store.state.$_Review.categories"
          :options="{ available: true, brands: true, rating: true, category: true }"
        />
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: 'OurCuratedSelections',
  components: {
    ProductGrid: () => import('@/components/v2/product-grid'),
    ProductFilter: () => import('@/components/v2/product-filter'),
    ModalFilterV2: () => import('@/components/global/modal/modal-filter-v2'),
  },
  data() {
    return {
      title: 'Our Curated Selections',
      clickedSection: null,
    };
  },
  computed: {
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    queryString() {
      return this.$store.state.$_Review.queryString;
    },
    products() {
      return this.$store.state.$_CuratedProduct.product;
    },
    loading() {
      return this.$store.state.$_CuratedProduct.loading;
    },
    showModalFilterV2() {
      return this.$store.state.modal.isModalShow.filterV2;
    },
    filterByQuery() {
      const queryObj = JSON.parse(JSON.stringify(this.queryString));
      const result = Object.keys(queryObj)
        .filter((key) => !key.includes('sort') && !key.includes('limit') && !key.includes('skip'))
        .reduce((obj, key) => {
          return Object.assign(obj, {
            [key]: queryObj[key],
          });
        }, {});
      return result;
    },
    showClearAllButton() {
      return (
        this.clickedSection === 'filter' ||
        this.$route.query.category ||
        this.$route.query.brands ||
        this.$route.query.origins ||
        this.$route.query.rating ||
        this.$route.query.available_for
      );
    },
  },
  watch: {
    queryString: {
      handler(newVal) {
        if (newVal) {
          this.apply();
          for (const key in newVal) {
            if (key !== 'sort' && key !== 'limit' && key !== 'skip') {
              if (newVal[key] === '') {
                this.handleSectionClick(null);
              }
            }
          }
        }
      },
      deep: true,
    },
    '$route.query'(to, from) {
      if (to != from) {
        this.getOurCuratedProducts();
      }
    },
    '$route.path'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.reset();
      }
    },
  },
  mounted() {
    this.$store.dispatch('$_Review/serialize', this.$route.query);
    this.getOurCuratedProducts();
    // this.getTitle();
    this.$store.commit('setPageInfo', {
      title: 'Our Curated Selections',
    });
    if (!this.$store.state.screen.isDesktop) {
      this.$store.dispatch('$_Review/getCategoriesChildren');
      this.$store.dispatch('$_Review/getBrandsOrigin');
      this.$store.dispatch('$_Review/getBrandsLetter');
    }
  },
  methods: {
    onDeleteItem(item, value) {
      const queryValue = JSON.parse(JSON.stringify(this.queryString[item]));
      if (queryValue) {
        if (item === 'brands') {
          const brands = queryValue.split(',');
          const index = brands.indexOf(value);
          brands.splice(index, 1);
          this.$store.commit('$_Review/SET_QUERY_STRING', {
            name: 'brands',
            value: brands.join(','),
          });
        }
        if (item === 'origins') {
          const origins = queryValue.split(',');
          const index = origins.indexOf(value);
          origins.splice(index, 1);
          this.$store.commit('$_Review/SET_QUERY_STRING', {
            name: 'origins',
            value: origins.join(','),
          });
        }
        if (item === 'category') {
          const category = queryValue.split(',');
          const index = category.indexOf(value);
          category.splice(index, 1);
          this.$store.commit('$_Review/SET_QUERY_STRING', {
            name: 'category',
            value: category.join(','),
          });
        }
        if (item === 'available_for') {
          const available = queryValue.split(',');
          const index = available.indexOf(value);
          available.splice(index, 1);
          this.$store.commit('$_Review/SET_QUERY_STRING', {
            name: 'available_for',
            value: available.join(','),
          });
        }
        if (item === 'rating') {
          const rating = queryValue.split(',');
          const index = rating.indexOf(value);
          rating.splice(index, 1);
          this.$store.commit('$_Review/SET_QUERY_STRING', {
            name: 'rating',
            value: rating.join(','),
          });
        }
      }
    },
    getOurCuratedProducts() {
      this.$store.dispatch('$_CuratedProduct/getOurCuratedProducts');
    },
    // async getTitle() {
    //   return new Promise((resolve, reject) => {
    //     try {
    //       resolve(this.$MS_SOCO_PUBLIC_API_URL.get('/products/featured/trending/title'));
    //     } catch (error) {
    //       reject(error);
    //     }
    //   }).then(({ data: response }) => {
    //     this.title = response.data;
    //   });
    // },
    checkSameQueryParams(a, b) {
      const obj_1 = Object.getOwnPropertyNames(a);
      const obj_2 = Object.getOwnPropertyNames(b);

      if (obj_1.length != obj_2.length) {
        return false;
      }

      for (let i = 0; i < obj_1.length; i++) {
        const attr = obj_1[i];
        if (a[attr] !== b[attr]) {
          return false;
        }
      }
      return true;
    },
    apply() {
      let query = Object.assign({}, this.$route.query);

      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'skip',
        value: 0,
      });

      if (this.queryString.category) {
        query = Object.assign(query, { category: this.queryString.category });
      } else {
        if (query.category) {
          delete query.category;
        }
      }

      if (this.queryString.available_for) {
        query = Object.assign(query, { available_for: this.queryString.available_for });
      } else {
        if (query.available_for) {
          delete query.available_for;
        }
      }

      if (this.queryString.origins) {
        query = Object.assign(query, { origins: this.queryString.origins });
      } else {
        if (query.origins) {
          delete query.origins;
        }
      }

      if (this.queryString.brands) {
        query = Object.assign(query, { brands: this.queryString.brands });
      } else {
        if (query.brands) {
          delete query.brands;
        }
      }

      if (this.queryString.rating) {
        query = Object.assign(query, { rating: this.queryString.rating });
      } else {
        if (query.rating) {
          delete query.rating;
        }
      }

      if (query.page) {
        query.page = 1;
      }

      if (!this.checkSameQueryParams(this.$route.query, query)) {
        this.$router.push({ query: query });
      }
    },
    listSelectedBrand(item) {
      const filterBrands = [];
      const arrayItem = item.split(',');
      if (this.$store.state['$_Review'].brandList.length) {
        arrayItem.map((x) => {
          const data = this.$store.state['$_Review'].brandList
            .filter((xx) => xx['_id'] === x)
            .map((brand) => ({ _id: brand._id, name: brand.name }));
          if (data.length) {
            filterBrands.push(data[0]);
          }
        });
      }
      return filterBrands;
    },
    listSelectedBrandOrigin(item) {
      const filterOrigins = [];
      const arrayItem = item.split(',');
      if (this.$store.state['$_Review'].countryList.length) {
        arrayItem.map((x) => {
          const data = this.$store.state['$_Review'].countryList
            .filter((xx) => xx['country_tag_id'].toString() === x)
            .map((origin) => ({ _id: origin.country_tag_id, name: origin.country }));
          if (data.length) {
            filterOrigins.push(data[0]);
          }
        });
      }
      return filterOrigins;
    },
    listAvailable(item) {
      const arrayItem = item.split(',');
      return arrayItem;
    },
    listCategoryItems(item) {
      const data = this.$store.state['$_Review'].categories;
      const temp = [];
      for (const i in data) {
        temp.push({
          id_category: data[i]._id,
          link_rewrite: data[i].link_rewrite,
          name: data[i].name,
          id_parent: '',
        });
        if (data[i].children != undefined && data[i].children.length) {
          const child = data[i].children;
          for (const j in child) {
            temp.push({
              id_category: child[j]._id,
              link_rewrite: child[j].link_rewrite,
              name: child[j].name,
              id_parent: child[j].id_parent,
            });
            if (child[j].children != undefined && child[j].children.length) {
              const sub = child[j].children;
              for (const k in sub) {
                temp.push({
                  id_category: sub[k]._id,
                  link_rewrite: sub[k].link_rewrite,
                  name: sub[k].name,
                  id_parent: sub[k].id_parent,
                });
              }
            }
          }
        }
      }
      return temp.filter((xx) => xx['id_category'] === item);
    },
    reset() {
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'category',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'brands',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'origins',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'available_for',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'rating',
        value: '',
      });
    },
    handleSectionClick(section) {
      this.clickedSection = section;
    },
  },
};
</script>

<style lang="scss" scoped>
.ocs-d {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  background-color: $white;
  padding: 30px 0 66px 0;
  .product-grid {
    flex: 1 0 auto;
    .container-list-filter {
      display: flex;
      position: relative;
      width: 100%;
      max-width: 900px;
      justify-content: space-between;
      overflow: hidden;
      .list-filter {
        display: flex;
        flex-direction: row;
        margin: 10px 0 15px;
        transition: transform 0.3s ease-in-out;
        overflow-x: auto;
        width: calc(100% - 100px);
        -ms-overflow-style: none;
        scrollbar-width: none;
        &::-webkit-scrollbar {
          display: none;
        }
        .list {
          display: flex;
          flex-direction: row;
          .item-list {
            display: flex;
            width: max-content;
            height: 28px;
            padding: 0px 8px;
            justify-content: center;
            align-items: center;
            gap: 8px;
            border: 1px solid #e5e5e5;
            background-color: white;
            border-radius: 4px;
            color: #231f20;
            font-family: 'lato-regular', sans-serif;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px;
            margin: 0 5px 0 0;
            cursor: pointer;
          }
        }
      }
      .list-reset {
        width: auto;
        height: 30px;
        padding: 0px 8px;
        border: none;
        color: #dc0034;
        font: 14px/28px 'lato-bold', sans-serif;
        letter-spacing: normal;
        cursor: pointer;
        margin: 10px 0 15px;
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
      }
    }
  }
  ::v-deep .icon_star {
    color: #f384a7;
    height: 15px;
  }
}
</style>
